import { Box } from '@mui/material';
import { useWindowSize } from "hooks/useWindowSize";
import React, { useEffect, useRef, useState } from 'react';

interface IProps {
    fixedHeight?: number;
    containerId?: string;
    children: (maxWidth: number, gap: number, margin: number) => React.ReactElement;
}

export const MprcRibbonListContainer = ({ fixedHeight, containerId, children }: IProps) => {
    const containerDiv = useRef<HTMLElement | undefined>(undefined);
    const [maxWidth, setMaxWidth] = useState(0);
    const { width } = useWindowSize();
    const gap = 16;
    const margin = 8;

    useEffect(() => {
        setMaxWidth((containerDiv?.current?.clientWidth ?? 0));
    }, [containerDiv.current, width]);

    return (
        <Box
            id={containerId ?? "carouselRibbonListContainer"}
            ref={containerDiv}
            sx={
                {
                    margin: "0 auto",
                    pb: 1,
                    pr: 1,
                    height: fixedHeight ? fixedHeight : "inherit",
                }
            }>
            {children(maxWidth, gap, margin)}
        </Box>
    );
};
